import React from 'react';
import { TextField } from '@material-ui/core';

const NoValueTextField = ({ ...textFieldProps }) => (
  <TextField {...textFieldProps} value="&ndash;" />
);

export default NoValueTextField;
